<template>
  <div class="main_r">
    <div class="page-top">
      <div class="title_line">通知列表</div>

      <!-- 筛选栏 -->
      <div class="filter-strip">
        <div class="filter-strip__fields">
          <div class="filter-field filter-field--compact">
            <label class="filter-field__label">终端用户</label>
            <el-input v-model="queryData.terminalUserId" placeholder="输入用户编号" clearable size="small"></el-input>
          </div>
        </div>
        <div class="filter-strip__actions">
          <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
          <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
          <el-button type="primary" size="small" plain icon="el-icon-refresh" @click="clickQuery">刷新</el-button>
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="table-section">
      <div class="table-container" ref="tableContainer">
        <el-table
          :data="dataList"
          class="notice-table"
          :height="tableHeight"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          @sort-change="handleSortChange">
          <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="userid" label="用户编号" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="noticeId" label="消息编号" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="170" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="Operation" label="操作" width="100" align="center" fixed="right">
            <template slot-scope="props">
              <div class="action-group">
                <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDelete(props.row)"></el-link>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page_no"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="page_size"
        layout="total, prev, pager, next, sizes, jumper"
        :total="dataListnum">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      queryData: {
        terminalUserId: ''
      },
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
    }
  },
  mounted () {
    this.NoticeNeedReadList()
    this.NoticeNeedReadNum()
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      if (column.property === 'Operation' || column.property === 'id' || column.property === 'userid' || column.property === 'noticeId' || column.property === 'createTime') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.NoticeNeedReadList()
      this.NoticeNeedReadNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.NoticeNeedReadList()
      this.NoticeNeedReadNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.NoticeNeedReadList()
      this.NoticeNeedReadNum()
    },
    clickQuery () {
      this.page_no = 1
      this.NoticeNeedReadList()
      this.NoticeNeedReadNum()
    },
    clickQueryReset () {
      this.queryData.terminalUserId = ''
      this.clickQuery()
    },
    ClickDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除？').then(function () {
        that.NoticeNeedReadDelete(row.id)
      })
    },
    NoticeNeedReadList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.terminalUserId = that.queryData.terminalUserId
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNeedReadNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.terminalUserId = that.queryData.terminalUserId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNeedReadDelete: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeNeedReadList()
            that.NoticeNeedReadNum()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.main_r {
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text, #1A1D21);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, #2563EB 0%, #3B82F6 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: #FFFFFF;
  border: 1px solid #E2E6EC;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 200px;
}

.filter-field__label {
  font-size: 12px;
  color: #5E6670;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E2E6EC;
  overflow: hidden;
}

/* 通知表格 */
.notice-table {
  /deep/ .el-table__body td {
    padding: 12px 0;
    background: #FFFFFF;
    border-bottom: 1px solid #EFF1F5;
  }

  /deep/ .el-table__body tr:hover > td {
    background: #EFF6FF !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: #F5F6F8 !important;
    border-bottom: 1px solid #E2E6EC;
    color: #5E6670;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: #F5F6F8;
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: #F5F6F8 !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: #FFFFFF;
    border-bottom: 1px solid #EFF1F5;
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: #EFF6FF !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: #FDECEC;
    }

    &.el-link--danger:hover {
      background-color: #FDECEC;
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #E2E6EC;
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid #EFF1F5;
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: #F5F6F8;
  border-bottom: 1px solid #EFF1F5;
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1D21;
}

.confirmMsg {
  font-size: 14px;
  color: #1A1D21;
  text-align: center;
  padding: 20px 0;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: #2563EB;
  border-color: #2563EB;
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: #3B82F6;
    border-color: #3B82F6;
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: #2563EB;
  background: #EFF6FF;
  border-color: #A8D0F5;

  &:hover {
    background: #2563EB;
    color: #FFF;
    border-color: #2563EB;
  }
}
</style>
